import { toQueryString } from 'utils/utils';

async function passportApi({ method, path, query, body }) {
	if (typeof window === 'undefined') {
		throw new Error('Trying to request server-side');
	}

	// let url = `https://santa.passports.stage.nbcunip.com${path || '/'}`;
	let url = `https://gg.passports.prod.nbcunip.com${path || '/'}`;
	if (query) {
		url += toQueryString(query);
	}

	const fetchOptions = {
		method,
	};

	if (body) {
		fetchOptions.headers = {
			'content-type': 'application/json',
		};
		fetchOptions.body = JSON.stringify(body);
	}

	try {
		const res = await fetch(url, fetchOptions);
		return res.json();
	} catch {
		console.log('Error!');
	}
}

const formatCode = (code) => {
	let formattedCode = '';
	const codeArray = code.split('');
	codeArray.forEach((char, i) => {
		if ((i + 1) % 4 === 0 && i !== code.length - 1) {
			formattedCode += char + '-';
		} else {
			formattedCode += char;
		}
	});
	return formattedCode.toUpperCase();
};

export const createNewPass = async (redemptionCode, platform, homeEnt) => {
	if (!redemptionCode || !platform) {
		throw new Error('No code or platform supplied');
	}
	let endpoint = homeEnt ? '/redeem/homeent' : '/redeem/new';
	return await passportApi({
		method: 'POST',
		path: endpoint,
		body: {
			code: formatCode(redemptionCode),
			platform,
		},
	});
};

export const updatePassWithBadge = async (redemptionCode, passId) => {
	if (!redemptionCode || !passId) {
		throw new Error('No code or pass id supplied');
	}
	return await passportApi({
		method: 'POST',
		path: '/redeem/additional',
		body: {
			code: formatCode(redemptionCode),
			passId: formatCode(passId),
		},
	});
};

export const formatDownloadLink = (link) => {
	if (link.startsWith('https')) {
		return link;
	}
	return `https://${link}`;
};

// MOCKS
const dummyCode = 'ABCD1234';
const dummyPassId = '123456781234';

export const mockCreateNewPass = async (redemptionCode, platform) =>
	new Promise((resolve, reject) => {
		if (!redemptionCode || !platform) {
			reject(new Error('No code or platform supplied'));
			return;
		}
		let response = {
			passId: dummyPassId,
			downloadLink: 'https://apple-wallet-dynamic.pow.io/get-pass?fileName=5591-7086-2242.pkpasses',
		};

		if (redemptionCode !== dummyCode) {
			response = {
				statusCode: 400,
				error: 'Bad Request',
				message: 'Invalid or already used redemption code',
			};
		}
		setTimeout(() => {
			resolve(response);
		}, 1500);
	});

export const mockUpdatePassWithBadge = async (redemptionCode, passId) =>
	new Promise((resolve, reject) => {
		if (!redemptionCode || !passId) {
			reject(new Error('No code or pass id supplied'));
			return;
		}
		let response = {
			passId: dummyPassId,
			downloadLink: 'Pass updated successfully',
		};
		const badCode = redemptionCode !== dummyCode;
		const badPass = passId !== dummyPassId;
		if (badCode || badPass) {
			response = {
				statusCode: 400,
				error: 'Bad Request',
				message: '',
			};
		}
		if (badCode) {
			response.message = 'Invalid or already used redemption code ';
		}
		if (badPass) {
			response.message = response.message + 'Pass ID does not exist';
		}
		setTimeout(() => {
			resolve(response);
		}, 1500);
	});
